export default __webpack_public_path__ + "static/media/hba.662ce9cd.svg";